// Shared Mobile parameters
let swiperParameters = {
  slidesPerView: 1.5,
  centeredSlides: true,
  spaceBetween: 20,
  allowTouchMove: true,
  
}

export default swiperParameters;